import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'

export type PayoutMethodProps = ModelProps<PayoutMethod>

/**
 * Payout method model.
 */
export class PayoutMethod extends Model<PayoutMethod> {
  id = Id.none

  @observable accessor type = 'Stripe' as const
  @observable accessor stripeAccountId = ''
  @observable accessor userId = Id.none
}
